<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :close-on-click-modal="false"
    width="30%"
    :visible.sync="view.visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px" class="position-dialog-form">
      <el-form-item label="岗位名称" prop="name">
        <el-input v-model="dataForm.name" placeholder="岗位名称"></el-input>
      </el-form-item>
      <el-form-item label="岗位编码" prop="code">
        <el-input v-model="dataForm.code" placeholder="岗位编码"></el-input>
      </el-form-item>
      <el-form-item label="联系方式" prop="contactPhone">
        <el-input v-model="dataForm.contactPhone" placeholder="联系方式(电话)"></el-input>
      </el-form-item>
<!--      <el-form-item label="租户" prop="tenantName">-->
<!--        <el-input-->
<!--        v-model="dataForm.tenantName"-->
<!--        readonly-->
<!--        placeholder="请选择"-->
<!--        style="width: 100%">-->
<!--        </el-input>-->
<!--      </el-form-item>-->
    </el-form>
    <el-row>
      <el-col style="text-align: right;">
        <el-button size="small" @click="view.visible = false">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="dataFormSubmit()">
          确定
        </el-button>       
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
  import {createPosition, editPosition, getPositionById} from "@/controller/sys"

  export default {
    data () {
      return {
        view: {
          visible: false,
          conheight: {
            height: this.$store.state.common.documentClientDefaultHeight * 0.9 - 410 + 'px',
            'overflow-y': 'auto'
          }
        },
        viewData: {
        },
        dataForm: {
          id: 0,
          name: '',
          code: '',
          contactPhone: '',
          tenantId: '',
          tenantName: '',
          orgId: ''
        },
        dataRule: {
          name: [
            { required: true, message: '岗位名称不能为空', trigger: 'blur' }
          ],
          code: [
            { required: true, message: '组织代码不能为空', trigger: 'blur' }
          ],
          // tenantName: [
          //   { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
          // ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.view.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.dataForm.tenantId = sessionStorage.getItem('tenantId')
          // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
          if (this.dataForm.id) {
            getPositionById(
                      {},this.dataForm.id
              ).then(data => {
                console.log("data",data)
                  if (data && data.code === '00') {
                      this.dataForm.code = data.body.positionCode
                      this.dataForm.name = data.body.positionName
                      this.dataForm.contactPhone = data.body.contactPhone || ''
                      this.dataForm.tenantId = data.body.tenantId
                      this.dataForm.orgId = data.body.orgId
                      // this.dataForm.tenantName = data.body.tenantName
                  }
              })
          }
        })
        // TODO
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            if(this.dataForm.id){
              editPosition(
                      {
                        'id': this.dataForm.id || undefined,
                        'positionCode': this.dataForm.code,
                        'positionName': this.dataForm.name,
                        'contactPhone': this.dataForm.contactPhone,
                        'orgId': this.dataForm.orgId,
                        'tenantId': this.dataForm.tenantId ||''
                      }
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.view.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              }).catch(error => {
                console.log(error)
              })
            }else{
              createPosition(
                      {
                        'id': this.dataForm.id || undefined,
                        'positionCode': this.dataForm.code,
                        'positionName': this.dataForm.name,
                        'contactPhone': this.dataForm.contactPhone,
                        'tenantId': this.dataForm.tenantId ||''
                      }
              ).then(data => {
                if (data && data.code === '00') {
                  this.$message({
                    message: '操作成功',
                    type: 'success',
                    duration: 1500,
                    onClose: () => {
                      this.view.visible = false
                      this.$emit('refreshDataList')
                    }
                  })
                } else {
                  this.$message.error(data.msg)
                }
              }).catch(error => {
                console.log(error)
              })
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .el-dialog__body{
    .position-dialog-form{
      width: 95%;
    }
  }
</style>
